import React from "react";

export default function SectionHeading({ eyebrow, title, description, align = "center", maxWidth = "max-w-3xl" }) {
  const alignClass = align === "left" ? "text-left" : "text-center mx-auto";
  return (
    <div className={`${maxWidth} ${alignClass}`} data-testid="section-heading">
      {eyebrow && <span className="badge-cd">{eyebrow}</span>}
      <h2 className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#0A1B5E] leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
